import { render, staticRenderFns } from "./CompanyNavigation.vue?vue&type=template&id=c10c8e7e&scoped=true"
import script from "./CompanyNavigation.vue?vue&type=script&lang=js"
export * from "./CompanyNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10c8e7e",
  null
  
)

export default component.exports